<template>
  <div class="tagBtn">
    <img class="img" :src="icon" alt />
    <span class="text">{{title}}</span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String
    },
    title: {
      type: String
    }
  },
  created() {
    console.log(this.icon, this.title);
  }
};
</script>

<style scoped>
.tagBtn {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  /* background-color: #fff;
  box-shadow: 0px 3px 24px 0px rgba(168, 187, 196, 0.17);
  border-radius: 10px; */
}
.img {
  width: 60px;
  height: 60px;
  margin: 30px 0 11px;
}

.text {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #00326b;
}
</style>



// WEBPACK FOOTER //
// src/page/newHomePage/btn.vue